import styled from "styled-components/macro";
import { rem } from "polished";
import { colors } from "../Styles.variables";

import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from "../../constants";

const Card = styled.article`
  background-color: ${colors.white};
  border-radius: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const CardPhoto = styled.div`
  border-radius: 10px 10px 0 0;
  height: 0;
  overflow: hidden;
  /* To keep aspect ratio of images on mobile */
  padding-top: calc(275 / 480 * 100%);
  position: relative;

  @media ${BREAKPOINT_TABLET} {
    /* To keep aspect ratio of images on tablet */
    padding-top: calc(217 / 455 * 100%);
  }

  @media ${BREAKPOINT_DESKTOP} {
    /* To keep aspect ratio of images on desktop */
    padding-top: calc(232 / 410 * 100%);
  }

  img,
  picture {
    background: transparent;
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &:focus {
    outline: ${rem("1px")} dotted;
    outline-offset: ${rem("2px")};
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${rem("15px")} ${rem("22px")} ${rem("22px")};
`;

export const CardGrid = styled.div`
  display: grid;
  gap: ${rem("22px")};

  @media ${BREAKPOINT_TABLET} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${BREAKPOINT_DESKTOP} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export default Card;
